@if (isFlat) {
    <div class="custom-fields-container">
        @for (customField of customFields; track $index) {
            <ng-container
                [ngTemplateOutlet]="customFieldTemplate"
                [ngTemplateOutletContext]="{
                    customField,
                    customFieldsForm,
                }"
            ></ng-container>
        }
    </div>
} @else {
    <div class="custom-fields-section" [class.open]="isSectionOpen" [class.show-error]="showError">
        <div class="section-header">
            <cerrix-icon
                class="section-collapse"
                icon="dropdown-closed"
                color="#001257"
                [size]="16"
                (click)="isSectionOpen = !isSectionOpen"
            ></cerrix-icon>
            <span class="section-title">{{ sectionName }}</span>
            <div class="section-header-warning">
                <cerrix-icon icon="warning" [size]="24" color="#B72121"></cerrix-icon>
                <span>Complete all required fields</span>
            </div>
        </div>
        <div class="custom-fields-container">
            @for (customField of customFields; track $index) {
                <ng-container
                    [ngTemplateOutlet]="customFieldTemplate"
                    [ngTemplateOutletContext]="{
                        customField,
                        customFieldsForm,
                    }"
                ></ng-container>
            }
        </div>
    </div>
}
<ng-template
    #customFieldTemplate
    let-customField="customField"
    let-customFieldsForm="customFieldsForm"
>
    <div
        [formGroup]="customFieldsForm"
        class="custom-field-item"
        [class.full-width]="fullWidthCustomTypes.includes(customField.customFieldType)"
    >
        <cerrix-field-wrapper
            [label]="customField.translation"
            type="secondary"
            [required]="customField.isRequired"
            [info]="customField.description"
        >
            @switch (customField.customFieldType) {
                @case (FieldType.TextField) {
                    <cerrix-input
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-input'"
                    ></cerrix-input>
                }
                @case (FieldType.TextBox) {
                    <cerrix-textarea
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-textarea'"
                    ></cerrix-textarea>
                }
                @case (FieldType.SingleSelect) {
                    <cerrix-select
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [options]="customField.options || []"
                        [useVisibility]="true"
                        [dataUiid]="'custom-field-' + customField.id + '-select'"
                    ></cerrix-select>
                }
                @case (FieldType.MultiSelect) {
                    <cerrix-autocomplete
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [options]="customField.options || []"
                        [useVisibility]="true"
                        [dataUiid]="'custom-field-' + customField.id + '-autocomplete'"
                    ></cerrix-autocomplete>
                }
                @case (FieldType.Checkbox) {
                    <cerrix-checkbox
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-checkbox'"
                    ></cerrix-checkbox>
                }
                @case (FieldType.Numeric) {
                    <cerrix-input-numeric
                        [placeholder]="customField.placeholder ?? ''"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-numeric'"
                    ></cerrix-input-numeric>
                }
                @case (FieldType.Date) {
                    <cerrix-datepicker
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-datepicker'"
                    ></cerrix-datepicker>
                }
                @case (FieldType.DateTime) {
                    <cerrix-datetime-picker
                        [placeholder]="customField.placeholder"
                        [formControlName]="customField.id"
                        [dataUiid]="'custom-field-' + customField.id + '-datetime-picker'"
                    ></cerrix-datetime-picker>
                }
                @case (FieldType.FinancialImpact) {
                    @if (currencies) {
                        <cerrix-financial-impact
                            [formControlName]="customField.id"
                            [internalOrganizations]="currentSelectedOrganizations"
                            [thirdParties]="currentSelectedThirdParties"
                            [currencyList]="currencies"
                            [dataUiid]="'custom-field-' + customField.id + '-financial-impact'"
                        ></cerrix-financial-impact>
                    }
                }
            }
        </cerrix-field-wrapper>
    </div>
</ng-template>
